const defaultParty = {
    displayOrder: Number.MAX_VALUE,
    display: true,
    previousElected: 0,
    totalElectedLeadingSeats: 0,
    totalVotes: "0",
    partyCode: "",
    partyName: "",
    partyHex: "",
};

const generateParty = (props = {}) => ({ ...defaultParty, ...props });

const defaultElectionData = {
    live: false,
    serverTime: 0,
    widgetTitle: "",
    widgetDescription: "",
    rsURL: "",
    widgetCTA: "",
    parties: [],
};
export const generateElectionData = (props = {}) => {
    return { ...defaultElectionData, ...props };
};

export const setPartyInfo = (obj) => {
    if (obj) {
        return {
            displayOrder:
                typeof obj.displayOrder === "number"
                    ? obj.displayOrder
                    : Number.MAX_VALUE,
            previousElected: obj.previousElected || 0,
            totalElectedLeadingSeats: obj.totalElectedLeadingSeats || 0,
            totalVotes:
                (obj.totalVotes && obj.totalVotes.toLocaleString("en-US")) ||
                "0",
            display: true,
        };
    }

    return {
        display: false,
    };
};

// Populate the Election Record
export const createElection = (json) => {
    const data = json.data || {};
    const config = data.config || {};
    const parties = data.parties || []; // Parties to be displayed within widget
    const live = json.live || false;
    const serverTime = json.serverTime || 0;

    return generateElectionData({
        live,
        serverTime,
        widgetTitle: config.widgetTitle || "",
        widgetDescription: config.widgetDescription || "",
        rsURL: config.rsURL || "",
        widgetCTA: config.widgetCTA || "",
        parties: Object.values(config.parties || [])
            .map((party) => {
                return generateParty(
                    Object.assign(
                        {
                            partyCode: party.partyCode || "",
                            partyName: party.partyName || "",
                            partyHex: party.partyHex || "",
                        },
                        // Has to be done through a function,
                        // otherwise values will not be overwritten on .find
                        setPartyInfo(
                            parties.find(
                                (item) => item.englishCode === party.partyCode
                            )
                        )
                    )
                );
            })
            .sort((a, b) => a.displayOrder - b.displayOrder),
    });
};
